import { createSelector } from 'reselect'
import { selectChatbotState } from '..'
import { BooleanSelector } from '../cohorts/types'
import { ChatbotState } from './reducer'

export const selectIfChatbotLoading: BooleanSelector = createSelector(
  selectChatbotState,
  (local: ChatbotState) => local.isLoading
)

export const selectIfChatbotInitialized: BooleanSelector = createSelector(
  selectChatbotState,
  (local: ChatbotState) => local.isInitialized ?? false
)
